module.exports = __webpack_public_path__ + "static/media/Product-Purchase-Guidance.de529f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-ASURION/Product-Purchase-Guidance.jpg
// module id = 3777
// module chunks = 0